import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Separator } from './ui/separator';
import { Calculator } from 'lucide-react';

export default function PriceDisplay({ quote, isCalculating, hasSlicerResults, stlAnalysis, quantity }) {
  if (stlAnalysis && !hasSlicerResults) {
    return (
      <Card>
        <CardContent className="p-4 sm:p-6">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-700"></div>
            <span className="ml-2">Analysiere Modell...</span>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (isCalculating) {
    return (
      <Card>
        <CardContent className="p-4 sm:p-6">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-700"></div>
            <span className="ml-2">Berechne Preis...</span>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!quote) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calculator className="w-5 h-5" />
          Preisberechnung
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-gray-600">Material:</p>
            <p className="font-medium">{quote.material}</p>
          </div>
          <div>
            <p className="text-gray-600">Farbe:</p>
            <p className="font-medium">{quote.color}</p>
          </div>
          <div>
            <p className="text-gray-600">Volumen:</p>
            <p className="font-medium">{Number(quote.scaled_volume ?? 0).toFixed(2)} cm³</p>
          </div>
          <div>
            <p className="text-gray-600">Gewicht:</p>
            <p className="font-medium">{Number(quote.scaled_weight ?? 0).toFixed(1)} g</p>
          </div>
          <div>
            <p className="text-gray-600">Infill:</p>
            <p className="font-medium">{Number(quote.infill_percent ?? 0).toFixed(0)}%</p>
          </div>
        </div>

        <Separator />

        {quantity > 1 && (
          <div className="flex justify-between items-center text-sm text-gray-600">
            <span>Stückpreis:</span>
            <span>€{Number(quote.price ?? 0).toFixed(2)}</span>
          </div>
        )}
        <div className="flex justify-between items-center text-lg font-bold">
          <span>Gesamtpreis{quantity > 1 ? ` (×${quantity})` : ''}:</span>
          <span className="text-green-600">€{(Number(quote.price ?? 0) * (quantity || 1)).toFixed(2)}</span>
        </div>
      </CardContent>
    </Card>
  );
}
